import { SVGProps } from 'react';

const Out = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="15"
        height="17"
        viewBox="0 0 15 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlSpace="preserve"
        strokeWidth={1}
        style={{ strokeLinejoin: 'round', strokeMiterlimit: 2 }}
        {...props}
    >
        <line x1={4.24219} y1={6.65674} x2={1.41376} y2={3.82831} strokeLinecap="round" />
        <line x1={1.41376} y1={3.82831} x2={4.24219} y2={0.999884} strokeLinecap="round" />
        <line x1={1.98438} y1={3.67163} x2={13.4844} y2={3.67163} strokeLinecap="round" />
        <line x1={13.4844} y1={3.67163} x2={13.4844} y2={15.1716} strokeLinecap="round" />
    </svg>
);

export default Out;
